module.exports = __webpack_public_path__ + "img/kelapa-pandan.1e4d87f8.jpeg";